import { render, staticRenderFns } from "./SalesFlashTableRow.vue?vue&type=template&id=ffbdcf78&"
import script from "./SalesFlashTableRow.vue?vue&type=script&lang=js&"
export * from "./SalesFlashTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports